import './bootstrap';
import 'alpinejs';


import TestReports from './alpine/TestReports';
new TestReports('TestReports');

import Issues from './alpine/Issues';
new Issues('Issues');

import Logs from './alpine/Logs';
new Logs('Logs');

import Terms from './alpine/Terms';
new Terms('Terms');

import DynamicFields from './alpine/DynamicFields';
new DynamicFields('DynamicFields');

import Dashboard from './alpine/Dashboard';
new Dashboard('Dashboard');

import LogIndex from './alpine/LogIndex';
new LogIndex('LogIndex');

import ScreenCast from './alpine/ScreenCast';
new ScreenCast('ScreenCast');

import Upload from './alpine/Upload';
new Upload('Upload');

import ReportingMenu from './alpine/ReportingMenu';
new ReportingMenu('ReportingMenu');

